/**
 * Горизонтальный слайдер отзывов на нативном scroll-snap.
 * Стрелки листают на одну карточку и гаснут на краях ленты.
 *
 * Разметка: x-data="reviewsSlider" на корне, x-ref="track" на ленте,
 * карточки — прямые потомки ленты.
 */
export default () => ({
    canPrev: false,
    canNext: false,

    init() {
        if (!this.$refs.track) {
            return;
        }

        this.update();
        this.$refs.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update(), { passive: true });
    },

    step() {
        const track = this.$refs.track;
        if (!track) {
            return 0;
        }

        const card = track.firstElementChild;

        if (!card) {
            return track.clientWidth;
        }

        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

        return card.offsetWidth + gap;
    },

    prev() {
        if (!this.$refs.track) {
            return;
        }

        this.$refs.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
    },

    next() {
        if (!this.$refs.track) {
            return;
        }

        this.$refs.track.scrollBy({ left: this.step(), behavior: 'smooth' });
    },

    update() {
        if (!this.$refs.track) {
            this.canPrev = false;
            this.canNext = false;
            return;
        }

        const { scrollLeft, scrollWidth, clientWidth } = this.$refs.track;

        // -1 — запас на дробные пиксели при масштабировании
        this.canPrev = scrollLeft > 1;
        this.canNext = scrollLeft + clientWidth < scrollWidth - 1;
    },
});
